import React from 'react';
import { ArrowRight, ShieldCheck, CreditCard, Lock } from 'lucide-react';
export function PurchaseSection() {
  return <div id="compra" className="bg-gradient-to-br from-purple-900 to-indigo-900 py-20 px-4 text-white relative overflow-hidden" data-id="element-164">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-165">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-purple-500 rounded-full blur-3xl" data-id="element-166"></div>
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-orange-500 rounded-full blur-3xl" data-id="element-167"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-168">
        <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-169">
          Recuperá tu tiempo y tu tranquilidad profesional
        </h2>
        <p className="text-xl text-purple-200 mb-12 max-w-2xl mx-auto" data-id="element-170">
          Todo el sistema, las actividades y los bonos exclusivos por un único
          pago hoy.
        </p>

        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/20 max-w-3xl mx-auto shadow-2xl" data-id="element-171">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-10" data-id="element-172">
            <div className="text-left" data-id="element-173">
              <p className="text-purple-200 text-lg mb-1" data-id="element-174">
                Precio Regular:{' '}
                <span className="line-through decoration-red-500 decoration-2" data-id="element-175">
                  $45.000
                </span>
              </p>
              <div className="flex items-baseline gap-2" data-id="element-176">
                <span className="text-6xl font-extrabold text-white" data-id="element-177">
                  $19.990
                </span>
                <span className="text-xl text-orange-400 font-bold" data-id="element-178">ARS</span>
              </div>
              <p className="text-sm text-purple-200 mt-2 bg-purple-800/50 px-3 py-1 rounded-full inline-block" data-id="element-179">
                Oferta válida solo por hoy
              </p>
            </div>

            <div className="flex flex-col gap-3 w-full md:w-auto" data-id="element-180">
              <a href="https://checkout.ebookditales.com/cart/42753407844415:1" className="bg-orange-500 hover:bg-orange-600 text-white text-xl font-bold py-4 px-8 rounded-xl shadow-lg hover:shadow-orange-500/30 transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 w-full md:w-auto" data-id="element-181">
                Acceder al MegaPack Ahora
                <ArrowRight className="w-6 h-6" data-id="element-182" />
              </a>
              <div className="flex justify-center gap-4 text-xs text-purple-200" data-id="element-183">
                <span className="flex items-center gap-1" data-id="element-184">
                  <Lock className="w-3 h-3" data-id="element-185" /> Pago Seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-186">
                  <CreditCard className="w-3 h-3" data-id="element-187" /> Acceso Inmediato
                </span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left border-t border-white/10 pt-8" data-id="element-188">
            <div className="flex items-start gap-3" data-id="element-189">
              <ShieldCheck className="w-6 h-6 text-teal-400 flex-shrink-0" data-id="element-190" />
              <div data-id="element-191">
                <h4 className="font-bold text-white" data-id="element-192">Garantía Total</h4>
                <p className="text-sm text-purple-200" data-id="element-193">
                  Material probado y verificado por profesionales.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-194">
              <CreditCard className="w-6 h-6 text-teal-400 flex-shrink-0" data-id="element-195" />
              <div data-id="element-196">
                <h4 className="font-bold text-white" data-id="element-197">Pago Único</h4>
                <p className="text-sm text-purple-200" data-id="element-198">
                  Sin suscripciones ni costos ocultos.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-199">
              <Lock className="w-6 h-6 text-teal-400 flex-shrink-0" data-id="element-200" />
              <div data-id="element-201">
                <h4 className="font-bold text-white" data-id="element-202">Descarga Segura</h4>
                <p className="text-sm text-purple-200" data-id="element-203">
                  Acceso inmediato a tu correo electrónico.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}